import { SelectHTMLAttributes, forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/cn';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
  selectSize?: 'md' | 'lg';
}

const sizes = {
  md: 'h-11 text-base',
  lg: 'h-13 text-md',
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select({ className, invalid, selectSize = 'md', children, ...rest }, ref) {
    return (
      <div className="relative w-full">
        <select
          ref={ref}
          aria-invalid={invalid || undefined}
          className={cn(
            'block w-full appearance-none rounded-sm border bg-surface pl-3 pr-9 text-ink',
            'transition-[border-color,box-shadow] duration-fast ease-enter',
            'focus-visible:outline-none focus-visible:border-primary focus-visible:shadow-focus',
            'disabled:bg-surface-sunken disabled:text-ink-disabled disabled:cursor-not-allowed',
            'hover:border-border-strong',
            sizes[selectSize],
            invalid
              ? 'border-error focus-visible:border-error focus-visible:shadow-[0_0_0_4px_var(--color-error-soft)]'
              : 'border-border-soft',
            className,
          )}
          {...rest}
        >
          {children}
        </select>
        <ChevronDown
          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted"
          aria-hidden
        />
      </div>
    );
  },
);
